import {
    array,
    oneOfType,
    shape,
    number,
    string,
    arrayOf,
    bool,
} from 'prop-types';
import { deliveryOffersShape } from './priceShape';
import pricesShape from './pricesShape';

export default shape({
    thumbnails: arrayOf(string),
    image_fullpath: string,
    banner: oneOfType([
        shape({
            categories: arrayOf(string),
            default: string,
        }),
        array,
    ]),
    category_slug: string,
    url: string.isRequired,
    absoluteUrl: string,
    minQuantity: number,
    productId: string,
    price: number,
    title: string,
    default_title: string.isRequired,
    score: number,
    article_id: number.isRequired,
    model_id: number.isRequired,
    on_sale: bool,
    has_sample: bool,
    brand_image_fullpath: string,
    rating_count: number,
    rating: number,
    has_free_delivery: bool,
    has_3x_payment: bool,
    prices: pricesShape.isRequired,
    models_count: number,
    objectID: string.isRequired,
    seller_id: number,
    seller_name: string,
    sku: number,
    delivery_offers: deliveryOffersShape,
});
